module.exports = __webpack_public_path__ + "static/media/sort_up.6c176668.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sort_up.svg
// module id = 568
// module chunks = 0